import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import SlideTrackItem from "./SlideTrackItem";
import AddSlideButton from "Components/AddSlideButton";

import Sidebar, {Tray} from 'Components/Sidebar';

export default class SlideTrack extends React.Component
{
    static propTypes = {
        storyId: PropTypes.string.isRequired,
        slides: PropTypes.array.isRequired,
        onClick: PropTypes.func.isRequired,
        changeElement: PropTypes.func.isRequired,

        current: PropTypes.string,
    };

    static defaultProps = {
        current: null
    };

    render()
    {
        const tray = <Tray>
            <AddSlideButton storyId={this.props.storyId} selectSlide={this.props.onClick} />
        </Tray>;

        const slides = _.orderBy(this.props.slides, 'position', 'asc');

        return <Sidebar tray={tray}>
            {
                _.map(slides, (slide, i) => <SlideTrackItem
                    key={slide.id}
                    slide={slide}
                    active={this.props.current === slide.id}
                    onClick={() => this.props.onClick(slide.id)}
                    changeElement={this.props.changeElement}
                    selectSlide={this.props.onClick}
                />)
            }
        </Sidebar>;
    }
}
